import { motion } from "framer-motion";
import { MessageSquare, Ruler, FileText, Wrench } from "lucide-react";
import { STEPS, waUrl } from "../data";

const ICONS = [MessageSquare, Ruler, FileText, Wrench];

export const Process = () => {
  return (
    <section id="proceso" className="bg-muted py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-electric">Cómo trabajamos</span>
            <h2 className="font-heading font-bold text-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-5">
              Sencillo, de<br />principio a fin.
            </h2>
          </div>
          <p className="text-muted-foreground max-w-sm">
            Un proceso claro y sin sorpresas. Tú nos cuentas y nosotros nos encargamos del resto.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {STEPS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="bg-white p-8 lg:p-10 relative"
                data-testid={`process-step-${i}`}
              >
                <span className="font-heading font-light text-6xl text-border leading-none">{s.n}</span>
                <span className="absolute top-8 right-8 grid place-items-center w-11 h-11 bg-ink text-white">
                  <Icon size={20} />
                </span>
                <h3 className="font-heading font-semibold text-ink text-xl mt-8">{s.title}</h3>
                <p className="text-muted-foreground mt-3 text-sm leading-relaxed">{s.text}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a href={waUrl()} target="_blank" rel="noopener noreferrer" data-testid="process-whatsapp-button" className="inline-flex items-center gap-3 bg-[#25D366] text-white font-semibold px-8 py-4 hover:brightness-95 transition-[filter] duration-300">
            Empezar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};
